<template>
  <div class="statusbar-overlay"></div>
</template>
<script>
  export default {}
</script>